import ComingSoon from "../components/ComingSoon";
import { Dna } from "lucide-react";

export default function BiologicalAgeComingSoon() {
  return (
    <ComingSoon
      title="Biological Age Assessment"
      description="Comprehensive longevity and aging analysis using validated biomarkers. This advanced feature will provide detailed insights into your biological age versus chronological age."
      icon={Dna}
      iconColor="text-purple-600"
      estimatedTime="Q2 2025"
    />
  );
}
